import React from "react";
import { ref, uploadBytes } from "firebase/storage";

import { FirebaseContext } from "@contexts";

function makeFilePath(fileExtension: string) {
  return `images/${fileExtension}`;
}

function getImageExtension(file: File) {
  const name = file.name;
  return `${name}`;
}

/**
 * Wrapper that handles logic to upload files to the cloud.
 * @returns {(file: File, metadata: any) => Promise<string>} URL to display images
 */
export function useUploadMultipleImage() {
  const { storage } = React.useContext(FirebaseContext);
  return React.useCallback(
    async (file: File, metadata: { [key: string]: string }) => {
      const filePath = makeFilePath(getImageExtension(file));
      const imageRef = ref(storage, filePath);
      try {
        // This uploads the file to the storage bucket, and a cloud
        // function adds the image to the appropriate module.
        return await uploadBytes(imageRef, file, {
          customMetadata: {
            metadata: JSON.stringify({ ...metadata, path: filePath }),
          },
        });
      } catch (ex) {
        console.error("Image upload failed", ex);
        throw ex;
      }
    },
    [storage],
  );
}
